// extracted by mini-css-extract-plugin
module.exports = {"item":"lay1_item_UC2Fx"};